import { render, staticRenderFns } from "./project-tree-selector.vue?vue&type=template&id=24935902&scoped=true&"
import script from "./project-tree-selector.vue?vue&type=script&lang=js&"
export * from "./project-tree-selector.vue?vue&type=script&lang=js&"
import style0 from "./project-tree-selector.vue?vue&type=style&index=0&id=24935902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24935902",
  null
  
)

export default component.exports